/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApprovalReportConsumption } from '../../models/approval-report-consumption';

export interface GetProductionOrderConsumption$Params {
  workCenterId: number;
  approvalReportDate: string;
  approvalReportLineId: number;
}

export function getProductionOrderConsumption(http: HttpClient, rootUrl: string, params: GetProductionOrderConsumption$Params, context?: HttpContext): Observable<StrictHttpResponse<ApprovalReportConsumption>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderConsumption.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
    rb.path('approvalReportLineId', params.approvalReportLineId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApprovalReportConsumption>;
    })
  );
}

getProductionOrderConsumption.PATH = '/api/v1/workCenter/{workCenterId}/approvals/{approvalReportDate}/items/{approvalReportLineId}/consumption';
